&nbsp;<a class="text-underline text-gray-600" (click)="onActionClick($event)" href="#">{{ action.link }}</a>
